import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class AuthorInfo extends React.PureComponent {
    static propTypes = {
        sourceReason: PropTypes.string,
        sourceAlias: PropTypes.string,
    };

    render() {
        const { sourceReason, sourceAlias } = this.props;

        return sourceReason === '其他' && sourceAlias ? (
            <div className={styles.authorInfo}>
                <div className={`${styles.spaceReduce} clearfix`}>
                    <div className={styles.userName}>
                        <span>{sourceAlias}</span>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default errorBoundary(AuthorInfo);
